import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getCertificatesPresentationSimple (params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getCertificate)
    })
  } else {
    const req = {
      url: '/api/presentaciones/getcertificadospresentacionsimples',
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      params,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getCertificatesPresentationSimple }
